import {ResourceLink} from '../../types';
import {appContextOptions} from '../appContextOptions';
import uniqBy from 'lodash-es/uniqBy';

export function createAddLinks(appId: string) {
    function addLinks(links: ResourceLink[]): void {
        const {useAppContext} = appContextOptions.instances.get(appId)!;
        const newLinks = useAppContext()._links?.concat(links);
        useAppContext()._links = uniqBy(newLinks, 'rel');
    }

    return addLinks;
}
